import { IGlobalState } from 'store';

export const selectors = {
	getActivityId: (state: IGlobalState) => state.followUps.close.activityId,
	getInitAction: (state: IGlobalState) => state.followUps.close.init,
	getCloseAction: (state: IGlobalState) => state.followUps.close.close,
	getOpen: (state: IGlobalState) => state.followUps.close.open,
	getFollowUps: (state: IGlobalState) => state.followUps.close.followUps,
	getOpportunityId: (state: IGlobalState) => state.followUps.close.opportunityId,
	getReasonCodes: (state: IGlobalState) => state.followUps.close.reasonCodes,
	getOnSuccess: (state: IGlobalState) => state.followUps.close.onSuccess,
	form: {
		getReasonForNoPurchase: (state: IGlobalState) => state.followUps.close.form.formData.reasonForNoPurchase,
		getComments: (state: IGlobalState) => state.followUps.close.form.formData.comments
	}
};
